<template>
  <v-app>
    <AppBar routeTo="login" btnName="Log in" />
    <v-container fill-height fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="6" md="5">
          <v-card width="500" class="mt-16 pa-4 custom-card" flat>
            <v-form @submit.prevent="register" v-model="isFormValid" ref="form">
              <div
                class="ml-4 text-h6 text-md-h5 text-lg-h4 font-weight-bold font-theme"
              >
                Sign up
              </div>
              <div class="ml-4 grey2--text mb-2">
                Please register to start using the platform
              </div>
              <v-card-text class="pb-0">
                <div class="mb-1 subtitle-2 grey3--text">Full name</div>
                <v-text-field
                  v-model="name"
                  placeholder="Full name"
                  :rules="fullNameRules"
                  outlined
                  dense
                  prepend-inner-icon="mdi-account"
                ></v-text-field>
                <div class="mb-1 subtitle-2 grey3--text">Email</div>
                <v-text-field
                  v-model="email"
                  placeholder="example@gmail.com"
                  :rules="emailRules"
                  outlined
                  dense
                  prepend-inner-icon="mdi-email"
                ></v-text-field>
                <div class="mb-1 subtitle-2 grey3--text">
                  Phone number (m-pesa)
                </div>
                <v-text-field
                  v-model="phone"
                  placeholder="07xxxxxxxx"
                  :rules="phoneNumberRules"
                  outlined
                  dense
                  prepend-inner-icon="mdi-phone"
                ></v-text-field>
                <div class="mb-1 subtitle-2 grey3--text">Password</div>
                <v-text-field
                  v-model="password"
                  outlined
                  :rules="passwordRules"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : passwordFieldType"
                  @click:append="togglePasswordVisibility"
                  placeholder="Enter your password"
                  dense
                  prepend-inner-icon="mdi-lock"
                ></v-text-field>
                <div class="mb-1 subtitle-2 grey3--text">Confirm password</div>
                <v-text-field
                  v-model="passwordConfirm"
                  outlined
                  :rules="passwordConfirmRules"
                  :append-icon="showPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPasswordConfirm ? 'text' : passwordFieldType"
                  @click:append="togglePasswordConfirmVisibility"
                  placeholder="Enter your password"
                  dense
                  prepend-inner-icon="mdi-lock"
                ></v-text-field>
                <v-checkbox
                  class="mt-2"
                  v-model="acceptedTerms"
                  label="I accept the Terms of service"
                  :rules="[
                    (v) =>
                      acceptedTerms || 'You must accept the terms and policies',
                  ]"
                ></v-checkbox>
                <v-btn
                  class="mt-3 primary white--text lowercase-text"
                  block
                  plain
                  :loading="$store.state.loading.registerBtn.load"
                  :disabled="$store.state.loading.registerBtn.disabled"
                  type="submit"
                  dark
                >
                  Sign up
                </v-btn>
                <v-card-text
                  class="display-6 text-center pr-0 row-pointer mt-2"
                >
                  <div class="grey2--text">
                    Already have an account?
                    <span
                      @click="routeToHandler"
                      class="hover--text row-pointer"
                      >Log in</span
                    >
                  </div>
                </v-card-text>
              </v-card-text>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import AppBar from "@/components/shared/AppBar";
export default {
  components: { AppBar },
  data() {
    return {
      name: "",
      email: "",
      phone: "",
      password: "",
      showPassword: false,
      passwordConfirm: "",
      showPasswordConfirm: false,
      referralCode: null,
      isFormValid: false,
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "Email must be valid",
      ],
      phoneNumberRules: [
        (v) => !!v || "Phone number is required",
        (v) => /^[0-9]{10}$/.test(v) || "Phone number must be 10 digits",
      ],
      fullNameRules: [
        (v) => !!v || "Full name is required",
        (v) =>
          /^[a-zA-Z\s]*$/.test(v) ||
          "Full name must contain only letters and spaces",
      ],
      passwordFieldType: "password",
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => v.length >= 8 || "Password must be at least 8 characters",
        (v) =>
          /[A-Z]/.test(v) ||
          "Password must contain at least one uppercase letter",
        (v) =>
          /[!@#$%^&*(),.?":{}|<>]/.test(v) ||
          "Password must contain at least one special character",
      ],
      passwordConfirmRules: [
        (v) => !!v || "Password confirmation is required",
        (v) => v === this.password || "Passwords do not match",
      ],
      acceptedTerms: false,
    };
  },
  mounted() {
    // Get the query string from the current URL
    const queryString = window.location.search;

    // Create a URLSearchParams object to parse the query string
    const params = new URLSearchParams(queryString);

    // Get the value of the 'token' parameter
    const referral = params.get("referral");

    if (referral) {
      this.referralCode = referral;
      // Now you can use the token for further processing, e.g., sending it to the server
    }
  },
  methods: {
    async register() {
      if (this.$refs.form.validate()) {
        // Form is valid, perform form submission or other actions

        await this.$store.dispatch("register", {
          name: this.name,
          email: this.email,
          phone: this.phone,
          password: this.password,
          passwordConfirm: this.passwordConfirm,
          referralCode: this.referralCode ? this.referralCode : null,
        });
        if (this.$store.state.user) {
          this.$router.push({ name: "register-success" });
        }
      }
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    togglePasswordConfirmVisibility() {
      this.showPasswordConfirm = !this.showPasswordConfirm;
    },
    routeToHandler() {
      this.$router.push({ name: "login" });
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
.row-pointer {
  cursor: pointer;
  color: #2c5282;
}
.custom-card {
  /* Add your additional border radius values */
  border-radius: 20px;
}
</style>
